export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5873.1b6c51e0.jpg";